import React, { Component } from 'react';
import { connect } from 'react-redux';

import ICS from '../../utils/ics';

import './AddToCalendarDropdown.css';

class AddToCalendarDropdown extends Component {
  constructor(props) {
    super(props);

    this.cal = new ICS('rypeapp.com', 'Rype, Inc//Lesson Scheduler//EN');
  }

  handleDownloadClick = () => {
    this.cal.download();
  }

  render() {
    const {
      booking,
      startDateTime,
      endDateTime,
      serviceName,
      teacherName,
      teacherSkypeUsername,
      studentSkypeUsername
    } = this.props.calData;

    // construct the string to add the event to Google Calendar
    const subject = `${serviceName} Lesson with ${teacherName}`;
    const homepage = 'https://members.rypeapp.com';
    const studentSkype = `Your Contact Info:\\nSkype Username: ${studentSkypeUsername}`;
    const details =
      subject +
      `\\n\\nReschedule or Cancel Appointment: ${homepage}/reservations\\n\\n\\n` +
      studentSkype;
    const location = `Teacher Skype Username: ${teacherSkypeUsername}`;
    const googleCalUrl =
      'http://www.google.com/calendar/event?action=TEMPLATE' +
      `&text=${subject}` +
      `&dates=${startDateTime
        .clone()
        .utc()
        .format('YYYYMMDDTHHmmss') + 'Z'}/` +
      `${endDateTime
        .clone()
        .utc()
        .format('YYYYMMDDTHHmmss') + 'Z'}` +
      `&details=${encodeURIComponent(details.replace(/\\n/g, '\n'))}` +
      `&location=${encodeURIComponent(location)}` +
      `&trp=true&sprop=${encodeURIComponent(homepage)}`;

    this.cal.addEvent({
      booking,
      summary: subject,
      description: details,
      location,
      beginDateTime: startDateTime,
      stopDateTime: endDateTime
    });

    return (
      <div className="AddToCalendarDropdown dropdown">
        <button
          className="btn btn-link dropdown-toggle"
          type="button"
          id="calendarDropdownButton"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          Add to Calendar
        </button>

        <div className="dropdown-menu" aria-labelledby="calendarDropdownButton">
          <a className="dropdown-item" rel="noopener noreferrer" target="_blank" href={googleCalUrl}>
            Google
          </a>

          <button className="dropdown-item" type="button" onClick={this.handleDownloadClick}>
            Outlook / iCal
          </button>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    customer: state.customer
  };
}

export default connect(mapStateToProps)(AddToCalendarDropdown);



// WEBPACK FOOTER //
// ./src/components/AddToCalendarDropdown/AddToCalendarDropdown.js